import { FC } from 'react';
import { Col, Row } from 'reactstrap';
import { Statistic, XOR } from 'Types';
import { JobStatisticCard } from 'Elements';

interface SharedProps {
	color?: number | string | undefined;
	statisticItems: Statistic[] | null;
}

type Props = SharedProps &
	XOR<
		{
			userType: 'businessPartner';
		},
		{
			userType: 'communityPartner';
		}
	>;

export const JobStatisticSection: FC<Props> = ({ color, statisticItems }) => {
	return (
		<Row>
			<>
				{statisticItems?.map((item) => {
					if (!item || item?.text == null || item?.text.trim() === '') {
						return null;
					}
					return (
						<Col key={item.title + item.text} sm={6}>
							<JobStatisticCard
								icon={item.icon}
								fill={color?.toString()}
								title={item?.title}
								desc={item?.text}
								className="mb-4"
							/>
						</Col>
					);
				})}
			</>
		</Row>
	);
};
